import { render, staticRenderFns } from "./ClinicDiseaseTempManage.vue?vue&type=template&id=6f7523fc&scoped=true"
import script from "./ClinicDiseaseTempManage.vue?vue&type=script&lang=js"
export * from "./ClinicDiseaseTempManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7523fc",
  null
  
)

export default component.exports